import { BmHttp as Http } from "../utils/Global";

export const ListCategoriaCertificados = async () => {
  try {
    const { data } = await Http().get(`get_categoria_certificados`);
    return data;
  } catch (error) {
    console.log("error", error);
  }
};

export const ListExamenCategoriaID = async (categoriaID) => {
  try {
    const { data } = await Http().post(`examen_categoria_id`, { categoria_id: categoriaID });
    return data;
  } catch (error) {
    console.log(error);
  }
}

export const ListTipoEstudio = async (categoriaID) => {
  try {
    const { data } = await Http().post(`tipo_estudio`, { categoria_id: categoriaID });
    return data;
  } catch (error) {
    console.log(error);
  }
}

export const ListTipo = async () => {
  try {
    const { data } = await Http().get(`tipo`);
    return data;
  } catch (error) {
    console.log(error);
  }
}

export const ProcedimientoNuevo = async (procedimiento) => {
  try {
    const { data } = await Http().post(`procedimiento_nuevos`, procedimiento);
    return data;
  } catch (error) {
    return error.response.data;
  }
}

export const ProcedimientoActualizar = async (procedimiento) => {
  try {
    const { data } = await Http().put(`procedimiento_actualizar`, procedimiento);
    return data;
  } catch (error) {
    return error.response.data;
  }
}




